import axios from 'axios';

// Detectar entorno
const isDevelopment = process.env.NODE_ENV === 'development';

// URL base según el entorno
// - Desarrollo local: usa localhost:3000 (tu backend en servidor)
// - Producción: usa el dominio real
const API_URL = process.env.REACT_APP_API_URL || 
  (isDevelopment 
    ? 'http://localhost:3000/api'  // Para desarrollo local (conexión al backend del servidor)
    : 'https://api.romanvalderrabanoelcatador.com/api'  // Para producción
  );

console.log('🔌 Conectando a API:', API_URL);
console.log('🌍 Entorno:', isDevelopment ? 'Desarrollo' : 'Producción');

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 15000, // 15 segundos de timeout
    withCredentials: false, // Cambiar a true si necesitas cookies
});

// Interceptor para añadir token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Log para debugging (solo en desarrollo)
        if (isDevelopment) {
            console.log('📤 Request:', config.method?.toUpperCase(), config.url);
        }
        
        return config;
    },
    (error) => {
        console.error('❌ Request error:', error);
        return Promise.reject(error);
    }
);

// Interceptor para respuestas
api.interceptors.response.use(
    (response) => {
        // Log para debugging (solo en desarrollo)
        if (isDevelopment) {
            console.log('📥 Response:', response.status, response.config.url);
        }
        return response;
    },
    (error) => {
        // Log detallado del error
        if (error.code === 'ECONNABORTED') {
            console.error('⏰ Timeout - El servidor no respondió en 15 segundos');
        } else if (error.response) {
            // El servidor respondió con un código de error
            console.error('❌ Error del servidor:', error.response.status, error.response.data);
        } else if (error.request) {
            // La petición se hizo pero no hubo respuesta
            console.error('🔌 Sin respuesta del servidor. Verifica que el backend esté corriendo en:', API_URL);
            console.error('💡 Para pruebas locales, asegúrate de que el backend esté activo en el servidor');
        } else {
            // Error al configurar la petición
            console.error('❌ Error:', error.message);
        }
        
        return Promise.reject(error);
    }
);

// Función helper para verificar conexión
export const checkApiConnection = async () => {
    try {
        const response = await api.get('/health');
        console.log('✅ Conexión API exitosa:', response.data);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('❌ Error conectando a API:', error.message);
        return { success: false, error: error.message };
    }
};

export default api;